import { type ReactNode, useState } from 'react'

import { message } from 'antd'
import cn from 'classnames'

import { useSseEquipmentNodes } from '@web/entities/equipment/api/use-sse-equipment-nodes.hook'
import { useAuthToken } from '@web/entities/user/lib/use-auth-token.hook'
import { Spinner } from '@web/shared/components/spinner'
import { EAuthStatus } from '@web/shared/enums/auth/auth-status.enum'
import useLocalFavIcon from '@web/shared/hooks/use-fav-icon.hook'

import styles from './app-bootstrap.module.css'

message.config({
  duration: 5,
  maxCount: 3,
  rtl: false
})

export const AppBootstrap = ({ children }: { children: ReactNode }) => {
  const isDevelop = import.meta.env.MODE !== 'production'
  const [loaded, setLoaded] = useState(false)
  useLocalFavIcon()
  const { authStatus } = useAuthToken()
  useSseEquipmentNodes()

  if (document.fonts) {
    document.fonts
      .load('1em Material Symbols Sharp')
      .then(() => setLoaded(true))
  }

  if (authStatus === EAuthStatus.PENDING) {
    return (
      <div className={styles.authLoading} role="status">
        <Spinner delay={0} className={styles.authSpinner} aria-hidden="true" />
        <span>Проверка токена авторизации…</span>
      </div>
    )
  }
  return loaded ? (
    <div
      className={cn(styles.appContainer, {
        [styles.appContainerDev]: isDevelop
      })}
    >
      {children}
    </div>
  ) : (
    <Spinner />
  )
}
